// Stub mínimo de i18n. Por ahora solo español de España.
// Los otros agentes pueden añadir claves a `translations` sin tocar `t`.

export const t = (key) => translations[key] ?? key;

const translations = {
  // Marca
  'brand.name': 'ISINAC',
  'brand.tagline': 'ISAN y BERNI construyen el universo ISINAC.',

  // Navegación / pasos
  'app.title': 'Visualizador acústico ISINAC',
  'nav.back': 'Atrás',
  'nav.next': 'Siguiente',
  'nav.finish': 'Finalizar',
  'nav.restart': 'Empezar de nuevo',

  // Paso 1 — Sala
  'step.1.title': 'Tu sala',
  'step.1.subtitle': 'Dinos cuánto mide la sala que quieres tratar.',
  'step.1.largo': 'Largo (m)',
  'step.1.ancho': 'Ancho (m)',
  'step.1.altura': 'Altura (m)',
  'step.1.surfaces': 'Materiales de las superficies',
  'step.1.ceiling': 'Techo',
  'step.1.floor': 'Suelo',
  'step.1.wall.1': 'Pared 1',
  'step.1.wall.2': 'Pared 2',
  'step.1.wall.3': 'Pared 3',
  'step.1.wall.4': 'Pared 4',

  // Paso 2 — Producto
  'step.2.title': 'Tu producto',
  'step.2.subtitle': 'Elige la línea ISINAC que mejor encaja con tu sala.',
  'step.2.economica': 'Económica',
  'step.2.media': 'Media',
  'step.2.premium': 'Premium',

  // Paso 3 — Distribución
  'step.3.title': 'Distribución de paneles',
  'step.3.subtitle': 'Coloca los paneles en techo y paredes.',
  'step.3.add': 'Añadir panel',
  'step.3.remove': 'Quitar panel',
  'step.3.auto': 'Distribución automática',

  // Paso 4 — Resultados
  'step.4.title': 'Resultados acústicos',
  'step.4.subtitle': 'Cómo queda tu sala antes y después del tratamiento.',
  'step.4.tr60.before': 'TR60 antes',
  'step.4.tr60.after': 'TR60 después',
  'step.4.sti': 'STI (inteligibilidad)',

  // Paso 5 — Datos cliente
  'step.5.title': 'Tus datos',
  'step.5.subtitle': 'Para enviarte el presupuesto en PDF.',
  'step.5.client.name': 'Nombre',
  'step.5.client.email': 'Email',
  'step.5.client.phone': 'Teléfono',
  'step.5.client.city': 'Ciudad',
  'step.5.client.notes': 'Notas (opcional)',

  // Paso 6 — Presupuesto
  'step.6.title': 'Tu presupuesto',
  'step.6.subtitle': 'Descárgate el PDF o pídenos que te lo enviemos.',
  'step.6.download': 'Descargar PDF',
  'step.6.email': 'Enviar por email',

  // Validaciones / errores
  'error.required': 'Este campo es obligatorio',
  'error.number.positive': 'Tiene que ser un número mayor que 0',
  'error.email.invalid': 'El email no parece válido',

  // Unidades
  'unit.meter': 'm',
  'unit.meter.square': 'm²',
  'unit.second': 's',
  'unit.hertz': 'Hz',
  'unit.euro': '€',
};
